import hierarchy from './../../zviz2/vendor/d3/d3-hierarchy/src/hierarchy/index';
import pack from './../../zviz2/vendor/d3/d3-hierarchy/src/pack/index';

import Vector2 from './../../zviz2/zviz/math/vector2';

// PackFunctions

export let getCircles = function(data, width, height, minScaleFact=0.5){
    let items = packItems(data, width, height);

    let bigCircles = [];
    let max = 0;
    let total = 0;

    let scale = getScale(items, width, height, minScaleFact);

    for(let i = 0; i < items.length; i++){
        let item = items[i];
        if(item.depth !== 1){
            continue;
        }
        let children = [];
        if(item.children){
            for(let c = 0; c < item.children.length; c++){
                let child = item.children[c];
                children.push({
                    position: {
                        x: scale * (child.x - item.x),
                        y: scale * (child.y - item.y)
                    },
                    r: scale * child.r,
                    color: child.data.color
                });
            }
        }

        // note that this array has an object which references back to
        // the array. Becareful not to end up in infinate recursions!
        bigCircles.push({
            id: item.data.id,
            r: scale*item.r,
            color: item.data.color,
            name: item.data.name,
            icon: item.data.icon,
            type: item.data.type,
            value: item.data.value,
            speed: new Vector2(),
            position: new Vector2(
                scale*item.r + Math.random() * (width - 2*scale*item.r), 
                scale*item.r + Math.random() * (height - 2*scale*item.r)
            ),
            box: [width, height],
            children: children,
            siblings: bigCircles,
            counter: 100,
            runs: 0
        });
    }

    return bigCircles;
}

let getScale = function(items, width, height, minScaleFact){
    let indexes = [];
    let max = 0;
    for(let i = 0; i < items.length; i++){
        let item = items[i];
        if(item.depth == 1){
            max = (max < item.r)? item.r: max;
            indexes.push(i);
        }
    }
    let total = 0;
    for(let i = 0; i < indexes.length; i++){
        let item = items[indexes[i]];
        // making sure the circles don't get too small
        item.r = Math.max(item.r, minScaleFact*max); 
        total += Math.PI * item.r * item.r;
    }

    let scale = Math.sqrt((0.4 * width * height) / total);
    // make sure the largest circle will fit in the window
    let s = (Math.min(height, width)-80) / (2 * max);
    return Math.min(scale, s);
}

export let packItems = function(data, width, height){
    data = hierarchy(data);
    let p = pack().size([width, height]);
    // p.padding((n) => ( n.depth == 2? 5: 20) );
    p.padding(4);
    // p.radius((n) => ( Math.sqrt(n.data.fact*n.data.value) ));
    return p(data).descendants();
}


export let calculatePosition = function(item){

    let time = 0.5;
    let fric = 0.75;
    let margin = 40;
    let padding = 40;
    if(window.innerWidth < 600){
        margin = 20;
        padding = 30;
    }
    let maxMovement = 0;

    let c = item;
    let siblings = c.siblings;
    let width = c.box[0];
    let height = c.box[1];
    c.runs++;

    c.position.add(c.speed.copy().multiply(time));
    c.speed.multiply(fric);

    // force to the center
    let dx = 0.5*width - c.position.x;
    let dy = 0.5*height - c.position.y;
    let force = new Vector2(
        0.2*(height/width) * dx / Math.abs(dx) * Math.pow(dx, 2),
        0.2*(width/height) * dy / Math.abs(dy) * Math.pow(dy, 2)
    );

    // force away from the edges (strong force)
    dx = 0;
    dy = 0;
    if(c.position.x - c.r < margin){
        dx = margin -1*(c.position.x - c.r);
    }
    if(c.position.x + c.r + margin > width){
        dx += width - (c.position.x + c.r + margin);
    }
    if(c.position.y - c.r < margin){
        dy = margin -1*(c.position.y - c.r);
    }
    if(c.position.y + c.r + margin > height){
        dy += height - (c.position.y + c.r + margin);
    }
    let f = {x: 0, y: 0};
    if(dx) f.x = 10 * Math.pow(dx, 3);
    if(dy) f.y = 10 * Math.pow(dy, 3);

    force.add(f);


    let maxRadius = 0;
    // force of other circle on this circle
    for(let t = 0; t < siblings.length; t++){
        let circle = siblings[t];
        if(c == circle) continue;

        if(! circle.position){
            console.log(circle);
        }
        let d = circle.position.copy().substract(c.position);
        let dist = d.length();
        dist -= circle.r + c.r + padding;
        if(dist < 0){
            force.add(d.normalize().multiply(0.3*dist * circle.r * circle.r));
        }

        maxRadius = (circle.r > maxRadius)? circle.r: maxRadius;
    }

    // Force should not grow too large
    if(force.length() > 100000){
        force.normalize().multiply(100000);
    }

    // make sure very small circles are not going to bounch around too much
    let rS = Math.max(0.2*maxRadius, c.r); 

    c.speed.add(force.devide(rS*rS).multiply(time));    

    if(c.counter == 1){
        // last step, if there is still a lot of movement
        // try to add some more calculation cycles
        let l = c.speed.length();
        if(l > 3){
            addToCounters(siblings, 20);
        }
    }

}

let addToCounters = function(siblings, count){
    for(let i = 0; i < siblings.length; i++){
        if(siblings[i].runs < 400){ // safety switch
            siblings[i].runs += count;
        }
    }
}
